import React from "react";
import bind from "memoize-bind";
import { sortBy, uniqBy } from "lodash";
import { Form, FormControl, FilterGroup, st } from "lib/index";

export default class ProductsListFilters extends React.PureComponent {
  handleFilterChange(prop, value) {
    this.handleFiltersChange({ [prop]: value });
  }

  handleFiltersChange(data) {
    const { filters, onFiltersChange } = this.props;
    onFiltersChange({
      ...filters,
      ...data,
    });
  }

  render() {
    const { aggregations, currentCompany, filters } = this.props;

    const locations = [];
    const product_types = [];

    if (aggregations && aggregations.location_names) {
      const locationData = aggregations.location_names.location_names.buckets;
      const productTypeData = aggregations.product_type.product_type.buckets;

      locationData.map((location) => {
        if (location.key === "-1") {
          locations.unshift([location.key, `${I18n.t("papp.common.none")} (${location.doc_count})`]);
        } else {
          locations.push([location.key, `${location.key} (${location.doc_count})`]);
        }
      });

      productTypeData.map((productType) => {
        product_types.push([
          productType.key,
          `${I18n.t(`activerecord.attributes.product_types.${productType.key}`)} (${productType.doc_count})`,
        ]);
      });
    }

    const suppliers = {};
    const fillSuppliers = () => {
      if (aggregations && aggregations.supplier_id) {
        const s = aggregations.supplier_id.supplier_id.buckets;
        s.map((supplier) => {
          const id = supplier.key;

          suppliers[id] = supplier.doc_count;
        });
      }
    };

    fillSuppliers();

    const supplierOptions = sortBy(
      uniqBy(
        [
          ...currentCompany.getPossibleSuppliers(),
          ...(st.authorize.member.role === "global_admin"
            ? st.authorize.user.accessed_companies.filter((c) => c.supplier)
            : []),
        ],
        (c) => c.id
      ),
      (c) => c.name
    ).map((c) => [c.id, `${c.name} (${suppliers[c.id] || 0})`]);

    return (
      <Form>
        <FilterGroup
          enabled={!!filters.product_type}
          defaultActive
          label={I18n.humanAttributeName("product", "type")}
          onClear={bind(this.handleFilterChange, this, "product_type", null)}
        >
          <FormControl.Select
            fluid
            search
            includeBlank
            value={filters.product_type}
            onChange={bind(this.handleFilterChange, this, "product_type")}
            options={product_types}
          />
        </FilterGroup>
        <FilterGroup
          enabled={!!filters.location_names}
          defaultActive
          label={I18n.humanAttributeName("product", "location")}
          onClear={bind(this.handleFilterChange, this, "location_names", null)}
        >
          <FormControl.Select
            fluid
            search
            includeBlank
            value={filters.location_names}
            onChange={bind(this.handleFilterChange, this, "location_names")}
            options={locations}
          />
        </FilterGroup>

        {currentCompany.agent && (
          <FilterGroup
            label={I18n.humanAttributeName("order", "supplier")}
            enabled={filters.supplier_id !== null}
            onClear={bind(this.handleFilterChange, this, "supplier_id", null)}
          >
            <FormControl.Select
              fluid
              search
              includeBlank
              value={filters.supplier_id}
              onChange={bind(this.handleFilterChange, this, "supplier_id")}
              options={supplierOptions}
            />
          </FilterGroup>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/ProductsListView/ProductsListFilters.jsx